import { useMemo } from 'react';

export const useProductLocation = () => {
    const { location } = window;
    const { pathname } = location;

    const result = useMemo(() => {
        const [, area, subarea, supplier, connection, product] = pathname.split('/');
        const parts = {
            area,
            subarea,
            supplier,
            connection,
            product
        };

        return Object.assign(location, { parts });
    }, [location, pathname]);

    return result;
};
